import { createRouter, Link } from "@tanstack/react-router";
import { rootRoute } from "./routes/__root";
import { toErrorDisplayMessage } from "@/lib/utils";
import { loginRoute } from "./routes/login";
import { authCallbackRoute } from "./routes/auth-callback";
import { privacyRoute } from "./routes/privacy";
import { termsRoute } from "./routes/terms";
import { lawfulUseRoute } from "./routes/lawful-use";
import { pricingRoute } from "./routes/pricing";
import { impressumRoute } from "./routes/impressum";
import { authenticatedRoute } from "./routes/_authenticated";
import { indexRoute } from "./routes/_authenticated/index";
import { crmRoute } from "./routes/_authenticated/crm";
import { leadsRoute } from "./routes/_authenticated/leads";
import { usageRoute } from "./routes/_authenticated/usage";
import { billingRoute } from "./routes/_authenticated/billing";
import { referralsRoute } from "./routes/_authenticated/referrals";
import { teamRoute } from "./routes/_authenticated/team";
import { affiliateRoute } from "./routes/_authenticated/affiliate";
import { leadSignalsRoute } from "./routes/_authenticated/lead-signals";
import { remindersRoute } from "./routes/_authenticated/reminders";
import { supportRoute } from "./routes/_authenticated/support";
import { adminRoute } from "./routes/_authenticated/admin";
import { settingsRoute } from "./routes/_authenticated/settings";

/** Static text only — no useTranslation, so no i18n __store dependency during router pending (avoids null __store crash). */
function RouterPending() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg text-sm text-text-muted">
      Wird geladen…
    </div>
  );
}

/** Kein i18n — Router-Fehler (z. B. Render in Route) fangen, statt weißer Seite vor Login. */
function RouterDefaultError({ error }: { error: unknown }) {
  let message = "Unbekannter Fehler.";
  try {
    const s = toErrorDisplayMessage(error);
    if (s.trim()) message = s;
  } catch {
    /* never let error UI throw */
  }
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-bg p-6">
      <p className="max-w-md text-center text-sm text-danger">{message}</p>
      <Link
        to="/login"
        className="rounded-lg border border-border bg-surface-2 px-4 py-2 text-sm font-medium text-text hover:bg-surface"
      >
        Zur Anmeldung
      </Link>
    </div>
  );
}

const routeTree = rootRoute.addChildren([
  loginRoute,
  authCallbackRoute,
  privacyRoute,
  termsRoute,
  lawfulUseRoute,
  pricingRoute,
  impressumRoute,           // ← NEU
  authenticatedRoute.addChildren([
    indexRoute,
    crmRoute,
    leadsRoute,
    usageRoute,
    billingRoute,
    referralsRoute,
    teamRoute,
    affiliateRoute,
    leadSignalsRoute,
    remindersRoute,
    supportRoute,
    settingsRoute,
    adminRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultPendingComponent: RouterPending,
  defaultPendingMs: 0,
  defaultErrorComponent: RouterDefaultError,
});
